import { DataItem, ServerCachesMetricsType } from "./types";

export function formatDataForPsh(data?: DataItem[]) {
  if (!data) {
    return null;
  }

  // Find the object with the most properties
  const referenceObject = data.reduce(
    (maxObj, currentObj) =>
      Object.keys(currentObj).length > Object.keys(maxObj).length
        ? currentObj
        : maxObj,
    {}
  );

  if (!referenceObject) {
    return null;
  }

  const keys = Object.keys(referenceObject).filter(key => key !== "timestamp");

  const PshFormattedData: {
    date: Date;
    type: string;
    values: number;
  }[][] = [];

  keys.forEach(key => {
    const filteredArray = data.filter(item => item[key]);

    const transformedArray = filteredArray.map(item => ({
      date: new Date(item.timestamp * 1000),
      type: key,
      values: Math.round(item[key] * 100)
    }));

    PshFormattedData.push(transformedArray);
  });

  return PshFormattedData;
}

export const sortMetricsByCaches = (
  a: ServerCachesMetricsType,
  b: ServerCachesMetricsType
) => {
  return b.values - a.values;
};

interface serverCachesNameTypes {
  opcache_isb_usage: string;
  apcu_hitrate: string;
  opcache_hitrate: string;
  opcache_usage: string;
  realpath_usage: string;
  apcu_usage: string;
  pcre_usage: string;
}

export const serverCachesName: serverCachesNameTypes = {
  opcache_isb_usage: "OPCache Interned Strings Buffer Usage",
  apcu_hitrate: "APCu Hitrate",
  opcache_hitrate: "OPCache Hitrate",
  opcache_usage: "OPCache Usage",
  realpath_usage: "RealPath Usage",
  apcu_usage: "APCu Usage",
  pcre_usage: "PCRE Usage"
};
